import React from 'react'
import {
	Drawer,
	Row,
	Space,
	Typography,
	List,
	Tag
} from 'antd'
import {
	CloseOutlined,
	DislikeOutlined,
	LikeOutlined
} from '@ant-design/icons'

interface IBadTask {
	name: string
	id: number
	count: number
}

interface TaskDetailRatingDrawerProps {
	tasks: IBadTask[]
	open: boolean
	onClose: () => void
	isGood?: boolean
}

const TaskDetailRatingDrawer: React.FC<TaskDetailRatingDrawerProps> = ({ tasks, open, onClose, isGood }) => (
	<Drawer
		title={(
			<Row justify="space-between" align="middle">
				<Space>
					<CloseOutlined style={{ color: '#aaa' }} onClick={onClose} />
					<Typography.Text strong>{isGood ? 'Detail úloh s palcom hore' : 'Detail úloh s palcom dole'}</Typography.Text>
				</Space>
			</Row>
		)}
		width={600}
		visible={open}
		onClose={onClose}
		closeIcon={null}
	>
		<List
			itemLayout="horizontal"
			dataSource={tasks}
			renderItem={(item) => (
				<List.Item key={item.id}>
					<List.Item.Meta
						avatar={isGood
							? <LikeOutlined style={{ color: 'green', fontSize: 18 }} />
							: <DislikeOutlined style={{ color: 'red', fontSize: 18 }} />}
						title={item.name}
						description={(
							<Tag color={isGood ? 'green' : 'red'}>
								{item.count}× hodnotené {isGood ? 'pozitívne' : 'negatívne'}
							</Tag>
						)}
					/>
				</List.Item>
			)}
		/>
	</Drawer>
)

export default TaskDetailRatingDrawer
